var CD_DB = {
baseUrl: "/products/",
diffusori: {
zefiro: {
nome: "ZEFIRO", slug: "diffusore-oli-essenziali-a-secco-smart-zefiro",
prezzo: 49, capM2: 35, capM3: 100, programmabile: true, timer: false,
portatile: false, presa: true, formato: 100,
varianti: [{ id: "57122886877571", t: "Nero" }, { id: "57122886910339", t: "Bianco" }],
livelli: { 1: [5, 480], 2: [15, 300], 3: [30, 120] }, consumoRif: { livello: 2, mlh: 0.046 },
breve: "Sempre collegato alla presa, programmabile da app"
},
tauer: {
nome: "TAUER", slug: "diffusore-oli-essenziali-a-secco-professionale-tauer",
prezzo: 99, capM2: 70, capM3: 200, programmabile: true, timer: true,
portatile: true, presa: false, formato: 100,
varianti: [{ id: "57122429010307", t: "Nero" }, { id: "57122429043075", t: "Argento" }],
livelli: { 1: [16, 300], 2: [16, 180], 3: [16, 60] }, consumoRif: { livello: 2, mlh: 0.16 },
breve: "A batteria fino a 24 h, programmabile da app, per spazi ampi"
},
zenith: {
nome: "ZENITH 2", slug: "diffusore-di-oli-essenziali-a-secco-alluminio-zenith",
prezzo: 69, capM2: 50, programmabile: false, timer: false,
portatile: true, presa: false, formato: 10,
varianti: [{ id: "56848261218691", t: "Nero" }],
modi: { 1: { nome: "Basso", mlh: 0.15 }, 2: { nome: "Medio", mlh: 0.6 }, 3: { nome: "Alto", mlh: 1.2 } },
breve: "Portatile in alluminio, a batteria, da spostare tra le stanze"
},
aura: {
nome: "AURA", slug: "diffusore-oli-essenziali-a-secco-portatile-aura",
prezzo: 29.9, capM2: 20, programmabile: false, timer: true, // 20 m²: dal Kit Antizanzare AURA
portatile: true, presa: false, formato: 10, soloFluidi: true,
varianti: [{ id: "56425599730051", t: "Aura" }],
breve: "Compatto, per auto e piccoli spazi, si spegne da solo dopo 1, 4 o 8 ore"
}
},
essenze: {
solo_agrumi:     { nome: "Solo Agrumi", slug: "miscela-solo-agrumi", tipo: "miscela", denso: false,
varianti: { 10: { id: "57986073067907", p: 12 }, 50: { id: "57717904408963", p: 39 } } },
agrumi_speziati: { nome: "Agrumi Speziati", slug: "miscela-agrumi-speziati", tipo: "miscela", denso: false,
varianti: { 10: { id: "57178335904131", p: 14.9 }, 100: { id: "57178335936899", p: 69 } } },
bosco_balsamico: { nome: "Bosco Balsamico", slug: "miscela-bosco-balsamico", tipo: "miscela", denso: true,
varianti: { 10: { id: "57177211863427", p: 12.9 }, 100: { id: "57177211896195", p: 59 } } },
lavande:         { nome: "Lavande", slug: "miscela-lavande", tipo: "miscela", denso: false,
varianti: { 100: { id: "57177911198083", p: 49 } } },
rosa_muschiata:  { nome: "Rosa Muschiata", slug: "miscela-rosa-muschiata", tipo: "miscela", denso: true,
varianti: { 10: { id: "57178400194947", p: 24.9 }, 50: { id: "57360319742339", p: 79 } } },
arancio_fiore:   { nome: "Arancio in Fiore", slug: "miscela-arancio-in-fiore", tipo: "miscela", denso: false,
varianti: { 10: { id: "57986071003523", p: 19 }, 50: { id: "57717903851907", p: 69 } } },
limone:          { nome: "Limone Bio", slug: "olio-essenziale-di-limone-bio", tipo: "olio", denso: false,
varianti: { 10: { id: "55275909611907", p: 12 }, 100: { id: "57176064131459", p: 49 } } },
lavanda_vera:    { nome: "Lavanda Vera Bio", slug: "olio-essenziale-di-lavanda-vera-bio", tipo: "olio", denso: false,
varianti: { 10: { id: "57755640627587", p: 19 } } },
mandarino:       { nome: "Mandarino Bio", slug: "olio-essenziale-di-mandarino-bio", tipo: "olio", denso: false,
varianti: { 10: { id: "55275728208259", p: 16 }, 100: { id: "62519417307523", p: 64.9 } } },
eucalipto_rad:   { nome: "Eucalipto Radiata Bio", slug: "olio-essenziale-di-eucalipto-radiata-bio", tipo: "olio", denso: false,
varianti: { 10: { id: "55276265079171", p: 14 } } },
legno_sacro:     { nome: "Legno Sacro", slug: "legno-sacro-sandalo-incenso-miscela-oli-essenziali-diffusione", tipo: "miscela", denso: true,
varianti: { 10: { id: "57961028977027", p: 34 }, 50: { id: "57358869168515", p: 149 } } },
incenso:         { nome: "Incenso Olibano Bio", slug: "olio-essenziale-di-incenso-olibano-bio", tipo: "olio", denso: false,
varianti: { 10: { id: "55276170183043", p: 15 } } }
},
temi: {
risveglio:      { nome: "Risveglio",      colore: "#d9b45a", esc: "solo_agrumi",     alt: "limone" },
concentrazione: { nome: "Concentrazione", colore: "#4f6f8a", esc: "bosco_balsamico", alt: "eucalipto_rad" },
purificare:     { nome: "Purificare",     colore: "#8fb3a8", esc: "limone",          alt: "eucalipto_rad" },
accoglienza:    { nome: "Accoglienza",    colore: "#b9764a", esc: "agrumi_speziati", alt: "arancio_fiore" },
relax:          { nome: "Relax",          colore: "#8a7aa6", esc: "lavande",         alt: "lavanda_vera" },
notte:          { nome: "Notte",          colore: "#3d3a52", esc: "mandarino",       alt: "lavanda_vera" },
raccoglimento:  { nome: "Raccoglimento",  colore: "#7a5c3e", esc: "legno_sacro",     alt: "incenso" }
},
kits: [
{ nome: "Kit Profumare Ogni Stanza", slug: "kit-profumare-ogni-stanza-zenith-miscele", prezzo: 79.9,
diffusore: "zenith", essenze: ["agrumi_speziati", "bosco_balsamico"] },
{ nome: "Kit Profumare Auto", slug: "kit-auto-aura-diffusore-oli-essenziali", prezzo: 54.9,
diffusore: "aura", essenze: ["limone", "lavanda_vera"] },
{ nome: "Kit Profumare Grandi Ambienti · Freschezza", slug: "kit-profumare-grandi-ambienti-diffusore-tauer-professionale-miscela", prezzo: 124.2,
diffusore: "tauer", essenze: ["solo_agrumi"] },
{ nome: "Kit Profumare Grandi Ambienti · Eleganza", slug: "kit-profumare-grandi-ambienti-diffusore-tauer-professionale-miscela", prezzo: 160.2,
diffusore: "tauer", essenze: ["rosa_muschiata"] },
{ nome: "Kit Profumare Grandi Ambienti · Profondità", slug: "kit-profumare-grandi-ambienti-diffusore-tauer-professionale-miscela", prezzo: 223.2,
diffusore: "tauer", essenze: ["legno_sacro"] }
],
safety: {
deciso: "2026-10-11",
esclusiPer: { bambini: [], animali: [], gravidanza: [] }
},
premium: { accoglienza: "rosa_muschiata" },
sconto: "Diffusore + olio essenziale o miscela: sconto del 10%",
presaAltezza: "1–1,5 m da terra" // 11/10/2026 Lorenza
};
CD_DB.fasce = [6, 8, 10, 12, 14, 16, 18, 20, 22];
CD_DB.attivita = {
negozio:  { nome: "Negozio", ambienti: [{ n: "Area vendita", m2: 50, tema: "accoglienza" }] },
studio:   { nome: "Studio professionale", ambienti: [{ n: "Sala d'attesa", m2: 20, tema: "relax" }, { n: "Studio", m2: 18, tema: "concentrazione" }] },
spa:      { nome: "Centro estetico / spa", ambienti: [{ n: "Reception e attesa", m2: 40, tema: "accoglienza" }, { n: "Cabina 1", m2: 15, tema: "relax" }, { n: "Cabina 2", m2: 15, tema: "relax" }] },
hotel:    { nome: "Hotel / B&B", ambienti: [{ n: "Hall", m2: 60, tema: "accoglienza" }, { n: "Area colazione", m2: 35, tema: "risveglio" }] },
ufficio:  { nome: "Ufficio", ambienti: [{ n: "Open space", m2: 60, tema: "concentrazione" }, { n: "Sala riunioni", m2: 25, tema: "purificare" }] },
ristoro:  { nome: "Ristorante / bar", ambienti: [{ n: "Ingresso", m2: 20, tema: "accoglienza" }, { n: "Servizi", m2: 10, tema: "purificare" }] },
olistico: { nome: "Studio olistico / yoga", ambienti: [{ n: "Sala pratica", m2: 40, tema: "raccoglimento" }, { n: "Accoglienza", m2: 15, tema: "accoglienza" }] }
};
if (typeof module !== "undefined") module.exports = CD_DB;
var CD_Engine = {
clamp: function (v, a, b) { return Math.max(a, Math.min(b, v)); },
sceltaDiffusore: function (mode, m2, opts) {
opts = opts || {};
var noPresa = !!opts.noPresa;
if (opts.auto) return { ids: ["aura"], nota: "Per l'abitacolo AURA è la scelta più comoda: compatto e a batteria." };
if (mode === "prog") {
if (m2 <= 35 && !noPresa) return { ids: ["zefiro"], nota: null };
if (m2 <= 70) return { ids: ["tauer"], nota: (m2 <= 35 && noPresa) ? "Senza una presa libera ti proponiamo TAUER, che funziona a batteria." : null };
return { ids: noPresa ? ["tauer", "tauer"] : ["tauer", "zefiro"],
nota: "Oltre 70 m² un solo diffusore non basta: ne servono due, uno per ciascuna zona dello spazio." };
}
if (mode === "timer") {
if (m2 <= 20) return { ids: ["aura"], nota: null };
return { ids: ["tauer"], nota: "TAUER ha il telecomando con timer di 1, 4 o 8 ore: lo accendi e si spegne da solo." };
}
if (m2 <= 50) return { ids: ["zenith"], nota: null };
return { ids: ["tauer"], nota: "Oltre 50 m² serve più copertura: TAUER è anche lui a batteria e si sposta facilmente." };
},
livello: function (intens, m2, cap) {
var l = intens, r = m2 / cap;
if (r > 0.7) l += 1;
if (r < 0.35) l -= 1;
return this.clamp(l, 1, 3);
},
mlh: function (devId, liv) {
var d = CD_DB.diffusori[devId];
if (d.modi) return d.modi[liv].mlh;
if (!d.livelli) return null;
var ref = d.livelli[d.consumoRif.livello];
var k = d.consumoRif.mlh / (3600 * ref[0] / (ref[0] + ref[1]));
var c = d.livelli[liv];
return k * 3600 * c[0] / (c[0] + c[1]);
},
temaPrevalente: function (slots) {
var w = {};
slots.forEach(function (s) { if (s && s.tema) w[s.tema] = (w[s.tema] || 0) + s.int; });
var best = null;
Object.keys(w).forEach(function (t) { if (!best || w[t] > w[best]) best = t; });
return best;
},
temiPresenti: function (slots) {
var seen = [];
slots.forEach(function (s) { if (s && s.tema && seen.indexOf(s.tema) < 0) seen.push(s.tema); });
return seen;
},
essenza: function (tema, devId) {
var t = CD_DB.temi[tema], d = CD_DB.diffusori[devId];
var id = t.esc;
var formatiDi = function (x) { return Object.keys(CD_DB.essenze[x].varianti).map(Number).sort(function (a, b) { return a - b; }); };
if (d.soloFluidi && CD_DB.essenze[id].denso) id = t.alt;
if (d.formato < 50 && formatiDi(id)[0] > 15) id = t.alt;
var e = CD_DB.essenze[id];
var formati = formatiDi(id);
var f = d.formato >= 50 ? formati[formati.length - 1] : formati[0];
return { id: id, formato: f, variantId: e.varianti[f].id, prezzo: e.varianti[f].p };
},
programma: function (slots, devId, m2) {
var d = CD_DB.diffusori[devId], rows = [], mlGiorno = 0, ore = 0, self = this;
var cap = d.capM2;
slots.forEach(function (s, i) {
if (!s || !s.tema) return;
var liv = self.livello(s.int, Math.min(m2, cap * 1.0), cap);
var h = self.mlh(devId, liv);
if (h !== null) mlGiorno += h * 2;
ore += 2;
var da = CD_DB.fasce[i], a = da + 2;
var last = rows[rows.length - 1];
if (last && last.a === da && last.livello === liv) { last.a = a; }
else rows.push({ da: da, a: a, livello: liv });
});
rows.forEach(function (r) {
if (d.livelli) { r.acceso = d.livelli[r.livello][0]; r.pausa = d.livelli[r.livello][1]; }
if (d.modi) r.modo = d.modi[r.livello].nome;
});
return { righe: rows, oreGiorno: ore, mlGiorno: d.livelli || d.modi ? mlGiorno : null };
},
durataGiorni: function (formatoMl, mlGiorno) {
if (!mlGiorno) return null;
return Math.max(1, Math.round(formatoMl / mlGiorno));
},
sovrapposte: function (a, b) {
for (var i = 0; i < a.length; i++) {
if (a[i] && a[i].tema && b[i] && b[i].tema && a[i].tema !== b[i].tema) return true;
}
return false;
},
risolviCasa: function (st) {
var self = this, out = { postazioni: [], note: [], kit: null };
var c1 = st.corsie[0];
var scelta = this.sceltaDiffusore(st.mode, st.m2, { noPresa: st.vincoli.indexOf("no_presa") >= 0, auto: st.auto });
if (scelta.nota) out.note.push(scelta.nota);
var tema1 = this.temaPrevalente(c1.slots) || "accoglienza";
var capTot = scelta.ids.reduce(function (s, id) { return s + CD_DB.diffusori[id].capM2; }, 0);
scelta.ids.forEach(function (devId, k) {
var quota = Math.round(st.m2 * CD_DB.diffusori[devId].capM2 / capTot);
out.postazioni.push(self.postazione(devId, k === 0 ? c1.nome : c1.nome + " · seconda zona", c1.slots, quota, tema1));
});
var altri = this.temiPresenti(c1.slots).filter(function (t) { return t !== tema1; });
if (altri.length) {
out.note.push("Un diffusore monta una sola essenza alla volta: in " + c1.nome.toLowerCase() + " abbiamo scelto quella del tema prevalente (" +
CD_DB.temi[tema1].nome + ") e la dosiamo con intensità diverse durante la giornata.");
}
var c2 = st.corsie[1];
if (c2 && this.temiPresenti(c2.slots).length) {
var tema2 = this.temaPrevalente(c2.slots);
var dev1 = scelta.ids[0];
if (!this.sovrapposte(c1.slots, c2.slots) && CD_DB.diffusori[dev1].portatile && scelta.ids.length === 1) {
var p = self.postazione(dev1, c2.nome, c2.slots, Math.min(c2.m2, CD_DB.diffusori[dev1].capM2), tema2);
p.riuso = true;
out.postazioni.push(p);
out.note.push("Le due atmosfere non si sovrappongono: lo stesso " + CD_DB.diffusori[dev1].nome +
" può spostarsi da una stanza all'altra. Ti basta cambiare flacone, con una breve pulizia tra un'essenza e l'altra.");
} else {
var noPresa = st.vincoli.indexOf("no_presa") >= 0, dev2;
if (c2.uso === "fissa") dev2 = (c2.m2 <= 35 && !noPresa) ? "zefiro" : "tauer";
else dev2 = c2.m2 <= 50 ? "zenith" : "tauer";
out.postazioni.push(self.postazione(dev2, c2.nome, c2.slots, c2.m2, tema2));
out.note.push("Hai scelto due atmosfere diverse nello stesso momento: per questo ti proponiamo due diffusori, uno per stanza.");
}
}
out.kit = this.kitMatch(out.postazioni);
this.noteSicurezza(st.vincoli, out);
if (out.postazioni.some(function (p) { return p.devId === "zefiro" && !p.riuso; })) {
out.note.push("ZEFIRO va collegato alla presa elettrica: serve una presa libera, consigliata ad un'altezza di " + CD_DB.presaAltezza + ".");
}
out.carrello = this.carrello(out.postazioni);
return out;
},
postazione: function (devId, nome, slots, m2, tema) {
var d = CD_DB.diffusori[devId];
var es = this.essenza(tema, devId);
var prog = this.programma(slots, devId, m2);
return {
devId: devId, nome: nome, m2: m2, tema: tema, essenza: es, programma: prog,
premium: this.premium(tema, devId, m2 > 35),
durata: this.durataGiorni(es.formato, prog.mlGiorno), slots: slots,
copertura: Math.min(100, Math.round(d.capM2 / Math.max(1, m2) * 100))
};
},
premium: function (tema, devId, ok) {
if (!ok || !CD_DB.premium || !CD_DB.premium[tema]) return null;
var id = CD_DB.premium[tema], d = CD_DB.diffusori[devId], e = CD_DB.essenze[id];
if (d.soloFluidi && e.denso) return null;
var formati = Object.keys(e.varianti).map(Number).sort(function (a, b) { return a - b; });
var f = d.formato >= 50 ? formati[formati.length - 1] : formati[0];
if (d.formato < 50 && f > 15) return null;
var kit = CD_DB.kits.filter(function (k) { return k.diffusore === devId && k.essenze.indexOf(id) >= 0; })[0] || null;
return { id: id, formato: f, prezzo: e.varianti[f].p, kit: kit };
},
kitMatch: function (postazioni) {
var kits = CD_DB.kits;
for (var i = 0; i < kits.length; i++) {
var k = kits[i];
var p = postazioni.filter(function (x) { return x.devId === k.diffusore && !x.riuso; })[0];
if (!p) continue;
var essenzeSol = postazioni.map(function (x) { return x.essenza.id; });
var comuni = k.essenze.filter(function (e) { return essenzeSol.indexOf(e) >= 0; });
if (comuni.length >= 1) return { kit: k, comuni: comuni };
}
return null;
},
noteSicurezza: function (vincoli, out) {
if (vincoli.indexOf("bambini") >= 0)
out.note.push("Con bambini piccoli in casa: diffondi a intensità bassa, in stanze arieggiate, mai mentre dormono nella stessa stanza, e chiedi al pediatra in caso di dubbi.");
if (vincoli.indexOf("animali") >= 0)
out.note.push("Con animali in casa, soprattutto gatti: lascia sempre loro la possibilità di uscire dalla stanza e chiedi al veterinario quali essenze evitare.");
if (vincoli.indexOf("gravidanza") >= 0)
out.note.push("In gravidanza o allattamento: preferisci intensità basse e chiedi al medico prima di usare oli essenziali.");
out.note.push("Posiziona il diffusore fuori dalla portata di bambini e animali, lasciando sempre libera la via d'uscita dalla stanza.");
},
carrello: function (postazioni) {
var items = [], ess = {};
postazioni.forEach(function (p) {
if (!p.riuso) items.push({ id: CD_DB.diffusori[p.devId].varianti[0].id, quantity: 1 });
ess[p.essenza.variantId] = 1;
});
Object.keys(ess).forEach(function (v) { items.push({ id: v, quantity: 1 }); });
var merged = {};
items.forEach(function (it) { merged[it.id] = (merged[it.id] || 0) + it.quantity; });
return Object.keys(merged).map(function (id) { return { id: parseInt(id, 10), quantity: merged[id] }; });
},
totale: function (postazioni) {
var t = 0, seen = {};
postazioni.forEach(function (p) {
if (!p.riuso) t += CD_DB.diffusori[p.devId].prezzo;
if (!seen[p.essenza.variantId]) { t += p.essenza.prezzo; seen[p.essenza.variantId] = 1; }
});
return Math.round(t * 100) / 100;
},
risolviAttivita: function (st) {
var self = this, out = { ambienti: [], note: [] };
var noPresa = st.vincoli.indexOf("no_presa") >= 0;
var oreGiorno = Math.max(0, st.chiude - st.apre);
var giorni = st.giorni.filter(Boolean).length;
var oreMese = oreGiorno * giorni * 4.33;
var mlMese = 0, diffTot = 0;
st.ambienti.forEach(function (a) {
var devId, n = 1;
if (a.m2 <= 35 && !noPresa) devId = "zefiro";
else { devId = "tauer"; n = Math.max(1, Math.ceil(a.m2 / 70)); }
var d = CD_DB.diffusori[devId];
var m2Unit = a.m2 / n;
var liv = self.livello(1, m2Unit, d.capM2); // B2B: intensità bassa di default
var h = self.mlh(devId, liv);
var es = self.essenza(a.tema, devId);
var ml = h * oreMese * n;
mlMese += ml; diffTot += n;
out.ambienti.push({
nome: a.n, m2: a.m2, tema: a.tema, devId: devId, n: n, livello: liv,
acceso: d.livelli[liv][0], pausa: d.livelli[liv][1], essenza: es, mlMese: ml,
premium: self.premium(a.tema, devId, true),
copertura: Math.min(100, Math.round(d.capM2 * n / Math.max(1, a.m2) * 100))
});
});
out.oreGiorno = oreGiorno; out.giorni = giorni;
out.mlMese = Math.round(mlMese);
out.diffusori = diffTot;
out.flaconiAnno = Math.max(1, Math.ceil(mlMese * 12 / 100));
out.note.push("Intensità bassa di default: lo spazio è condiviso con clienti che non hanno scelto il profumo.");
if (out.ambienti.some(function (a) { return a.devId === "zefiro"; }))
out.note.push("ZEFIRO va collegato alla presa elettrica: in ogni ambiente dove lo proponiamo serve una presa libera, consigliata ad un'altezza di " + CD_DB.presaAltezza + ".");
out.note.push("Posiziona i diffusori fuori dalla portata di bambini e animali, lasciando sempre libera la via d'uscita dalla stanza.");
var post = out.ambienti.map(function (a) { return { devId: a.devId, essenza: a.essenza, n: a.n }; });
var items = {};
post.forEach(function (p) {
var v = CD_DB.diffusori[p.devId].varianti[0].id;
items[v] = (items[v] || 0) + p.n;
items[p.essenza.variantId] = 1;
});
out.carrello = Object.keys(items).map(function (id) { return { id: parseInt(id, 10), quantity: items[id] }; });
var tot = 0, seen = {};
post.forEach(function (p) {
tot += CD_DB.diffusori[p.devId].prezzo * p.n;
if (!seen[p.essenza.variantId]) { tot += p.essenza.prezzo; seen[p.essenza.variantId] = 1; }
});
out.totale = Math.round(tot * 100) / 100;
out.totaleDiffusori = post.reduce(function (s, p) { return s + CD_DB.diffusori[p.devId].prezzo * p.n; }, 0);
return out;
}
};
if (typeof module !== "undefined") module.exports = CD_Engine;
